/* eslint-disable max-len */
/* eslint-disable sort-keys-fix/sort-keys-fix */
export const anmTrialMessages = {
    // General
    'anmTrial.back': 'BACK TO SAAS MANAGEMENT',

    // Welcome
    'anmTrial.welcome.title': 'Welcome to Auvik Network Management!',
    'anmTrial.welcome.description.1':
        'Simplifying and streamlining network documentation and monitoring is our mission.',
    'anmTrial.welcome.description.2':
        'We have created a <span style="font-weight:600;">fast, friendly and automated</span> onboarding experience to make your transition effortless.',
    'anmTrial.welcome.description.3':
        'This guide will walk you through the initial setup of Auvik. <span style="font-weight:600;">In under 20 minutes</span>, you’ll learn something new about your network and be managing it based on best practices without the effort that’s required with other solutions.',
    'anmTrial.welcome.tos':
        'I’ve reviewed and accepted Auvik’s privacy notice, which details how my personal information will be processed, and <a href="https://auvik.com/terms" target="_blank" rel="noopener noreferrer nofollow">Auvik’s terms of service</a>.',
    'anmTrial.welcome.letsStartButton': 'LET’S START YOUR TRIAL',
    'anmTrial.welcome.createTrial.errorNotification':
        'An error occurred creating your trial.',

    // Graphic
    'anmTrial.welcome.graphic': 'Set up in 5 easy steps!',

    // Error creating trial
    'anmTrial.error.header': "Oh no, we couldn't set up your trial!",
    'anmTrial.error.body':
        "Your Auvik Network Management trial setup wasn't completed as expected. Please contact our support team to assist you with this.",
    'anmTrial.error.support': 'Contact support',

    // Footer
    'anmTrial.footer.text':
        'Do you prefer to have our technical sales team walk you through your deployment?',
    'anmTrial.footer.contactUs': 'CONTACT US',

    // Redirect
    'anmTrial.redirect.title': 'Welcome to Auvik Network Management!',
    'anmTrial.redirect.failed.header':
        "Oh no, we couldn't redirect you to Auvik Network Management!",
    'anmTrial.redirect.failed.body':
        'Please try again. If this error continues, please <a href="mailto:sales@auvik.com">contact support</a>.'
};
